/// <reference types="./admin.d.mts" />
import * as $maintenance from "../../../common/data/maintenance.mjs";
import * as $decrypt from "../../../common/decrypt.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $function from "../../../gleam_stdlib/gleam/function.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $effect from "../../../lustre/lustre/effect.mjs";
import * as $state from "../../data/model/state.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $ask from "../../frontend/ask.mjs";
import * as $middleware from "../../frontend/middleware.mjs";
import { toList } from "../../gleam.mjs";

export function fetch_maintenance(_) {
  return $middleware.require_access_token(
    (access_token) => {
      return $effect.from(
        (dispatch) => {
          return $function.tap(
            undefined,
            (_) => {
              let _pipe = $ask.to(new $ask.Heimdall(), toList(["maintenance"]));
              let _pipe$1 = $ask.bearing(_pipe, access_token);
              let _pipe$2 = $ask.expect(
                _pipe$1,
                $decrypt.optional_field(
                  "org",
                  $maintenance.decoder(),
                  (org) => {
                    return $decrypt.optional_field(
                      "frozen",
                      $maintenance.decoder(),
                      (frozen) => { return $decode.success([org, frozen]); },
                    );
                  },
                ),
              );
              let _pipe$3 = $ask.notify(
                _pipe$2,
                (maintenance) => {
                  let org = maintenance[0];
                  let frozen = maintenance[1];
                  let msg = new $msg.ApiReturnedMaintenance(org, frozen);
                  return dispatch(msg);
                },
              );
              let _pipe$4 = $ask.error(
                _pipe$3,
                (error) => {
                  let _pipe$4 = $string.inspect(error);
                  let _pipe$5 = new $msg.ApiErroredMaintenance(_pipe$4);
                  return dispatch(_pipe$5);
                },
              );
              return $ask.run(_pipe$4);
            },
          );
        },
      );
    },
  );
}
